export const getOrgId = () => {
  const match = window.location.pathname.match(/^\/o\/(\d+)\/?.*$/);
  return match ? match[1] : false;
};
